// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GnSE","largestCol":"styles_largestCol__U9BO7","smallestCol":"styles_smallestCol__1udtH"};